import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import AffiliateDashboardPromotionLink from 'modules/affiliate-dashboard/components/affiliate-dashboard-promotion-link';
import { useAffiliateDashboardPromotion } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-promotion';
import { AffiliateCard, AffiliateCardTitle, AffiliateStatRow } from 'modules/affiliate/components/affiliate-card';
import { Hint } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AffiliatePromotionProps {
  affiliateId?: string;
}
const AffiliateDashboardPromotion = t0 => {
  const $ = _c(44);
  const {
    affiliateId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    data: affiliatePromotion
  } = useAffiliateDashboardPromotion();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.affiliate_dashboard.promote_first");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <AffiliateCardTitle>{t1}</AffiliateCardTitle>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("dashboard.affiliate_dashboard.promote_second");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p className="text-text-tertiary">{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="flex flex-col gap-1.5">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== affiliateId) {
    t6 = <AffiliateDashboardPromotionLink affiliateId={affiliateId} />;
    $[11] = affiliateId;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("dashboard.affiliate.last_30_days");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("dashboard.affiliate_dashboard.freemium_registrations_new");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <Hint label={t7}>{t8}</Hint>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== affiliatePromotion?.freeRegistrationsCount) {
    t10 = affiliatePromotion?.freeRegistrationsCount ?? <Skeleton />;
    $[20] = affiliatePromotion?.freeRegistrationsCount;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <AffiliateStatRow label={t9}>{t10}</AffiliateStatRow>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("dashboard.affiliate_dashboard.active_customers_tooltip");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("dashboard.affiliate_dashboard.active_customers");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <Hint label={t12}>{t13}</Hint>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== affiliatePromotion?.paidCount) {
    t15 = affiliatePromotion?.paidCount ?? <Skeleton />;
    $[32] = affiliatePromotion?.paidCount;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t14 || $[35] !== t15) {
    t16 = <AffiliateStatRow label={t14}>{t15}</AffiliateStatRow>;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t11 || $[38] !== t16) {
    t17 = <dl className="border-border-200 flex flex-col gap-2 border-t pt-4">{t11}{t16}</dl>;
    $[37] = t11;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t17 || $[41] !== t5 || $[42] !== t6) {
    t18 = <AffiliateCard>{t5}{t6}{t17}</AffiliateCard>;
    $[40] = t17;
    $[41] = t5;
    $[42] = t6;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
};
export default AffiliateDashboardPromotion;